import mod from "-!./HowItWorks.js?vue&type=script&lang=js&"; export default mod; export * from "-!./HowItWorks.js?vue&type=script&lang=js&"